<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { messageStamp } from 'shared/helpers/timeHelper';

const props = defineProps({
  inboxName: {
    type: String,
    default: '',
  },
  inboxIcon: {
    type: String,
    default: '',
  },
  scheduledAt: {
    type: Number,
    default: 0,
  },
  deliverySummary: {
    type: Object,
    default: null,
  },
  attachmentsCount: {
    type: Number,
    default: 0,
  },
});

const { t } = useI18n();

const summary = computed(() => ({
  total: props.deliverySummary?.total || 0,
  sent: props.deliverySummary?.sent || 0,
  sending: props.deliverySummary?.sending || 0,
  deliveryUnknown: props.deliverySummary?.delivery_unknown || 0,
  failed: props.deliverySummary?.failed || 0,
  skipped: props.deliverySummary?.skipped || 0,
  opened: props.deliverySummary?.opened || 0,
  clicked: props.deliverySummary?.clicked || 0,
  openCount: props.deliverySummary?.open_count || 0,
  clickCount: props.deliverySummary?.click_count || 0,
}));

const hasSummary = computed(
  () =>
    summary.value.sent ||
    summary.value.sending ||
    summary.value.deliveryUnknown ||
    summary.value.failed ||
    summary.value.skipped
);
</script>

<template>
  <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
    {{ t('CAMPAIGN.EMAIL.CARD.CAMPAIGN_DETAILS.SENT_FROM') }}
  </span>
  <div class="flex items-center gap-1.5 flex-shrink-0">
    <Icon :icon="inboxIcon" class="flex-shrink-0 text-n-slate-12 size-3" />
    <span class="text-sm font-medium text-n-slate-12">
      {{ inboxName }}
    </span>
  </div>

  <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
    {{ t('CAMPAIGN.EMAIL.CARD.CAMPAIGN_DETAILS.ON') }}
  </span>
  <span class="text-sm font-medium truncate text-n-slate-12">
    {{ messageStamp(new Date(scheduledAt), 'LLL d, h:mm a') }}
  </span>
  <span v-if="hasSummary" class="text-xs font-medium text-n-slate-10">
    {{
      t('CAMPAIGN.EMAIL.CARD.CAMPAIGN_DETAILS.DELIVERY_SUMMARY', {
        total: summary.total,
        sent: summary.sent,
        sending: summary.sending,
        deliveryUnknown: summary.deliveryUnknown,
        failed: summary.failed,
        skipped: summary.skipped,
        opened: summary.opened,
        clicked: summary.clicked,
        openCount: summary.openCount,
        clickCount: summary.clickCount,
      })
    }}
  </span>
  <span v-if="attachmentsCount" class="text-xs font-medium text-n-slate-10">
    {{
      t('CAMPAIGN.EMAIL.CARD.CAMPAIGN_DETAILS.ATTACHMENTS', {
        count: attachmentsCount,
      })
    }}
  </span>
</template>
